/* eslint-disable */

import jsonp from "@/libs/api.request.js";
import { reactive, watch, ref, onMounted, createApp, nextTick } from "vue";
import Tabs from "@/class/Tabs";
import axios from "axios";
// import usePages from '@/composables/usePages'

type dataList = Array<any>;
type set = {
  ID: string;
  Articletype: string;
  ApplicationCode: string;
  CategoryCode: string;
  SortIndex: string;
  GroupIndex: string;
  Title: string;
  TitleClass: string;
  Summary: string;
  Author: string;
  Keyword: string;
  HomeImagePath: string;
  PublishDate: string;
  OutLink: string;
  AccessoryLink: string;
  AccessoryTitle: string;
};
type list = {
  data: set[];
};

export function useNotice() {
  let list: list = reactive({ data: [] });

  onMounted(() => {
    fetchContent();
  });

  function format(data: Array<Array<string>>) {
    return data.slice(1, data.length).map((i: string[]) => {
      return {
        ID: i[0],
        Articletype: i[1],
        ApplicationCode: i[2],
        CategoryCode: i[3],
        SortIndex: i[4],
        GroupIndex: i[5],
        Title: i[6],
        TitleClass: i[7],
        Summary: i[8].split(";")[1],
        Author: i[9],
        Keyword: i[10],
        HomeImagePath: i[11],
        PublishDate: i[12],
        OutLink: i[13] ? i[13] : "./#/Article?ArticleID=" + i[0],
        AccessoryLink: i[14],
        AccessoryTitle: i[15],
      };
    });
  }

  function fetchContent() {
    jsonp("https://news-my.web.sdo.com/UniInterface/news/newslist.asp", {
      CategoryCode: 7790,
      pageSize: 7,
      pageIndex: 0,
      Keyword: "",
      Type: "json",
    }).then((res: any) => {
      if (res.Code == 0 && res.TotalCount > 0) {
        list.data = format(res.dataList as dataList);
      } else {
        list.data = [];
      }
    });
  }

  return { list, fetchContent };
}
